<template>
  <div class="loader">
    <div class="loader__wrapper">
      <div class="loader__slice" :style="{ width: size, height: size, borderTopColor: color }"></div>
      <div class="loader__slice" :style="{ width: size, height: size, borderTopColor: color }"></div>
      <div class="loader__slice" :style="{ width: size, height: size, borderTopColor: color }"></div>
      <div class="loader__slice" :style="{ width: size, height: size, borderTopColor: color }"></div>
      <span class="loader__label" :style="{ color: color }">
        {{ $t('shared.message.loading') }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loader',
  props: {
    size: { type: String, default: '32px' },
    color: { type: String, default: 'var(--white)' }
  }
};
</script>

<style lang="less" scoped>
.loader {
  display: inline-block;
  animation: fade-in 0.15s forwards;
  z-index: 9998;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: darken(rgba(90, 26, 214, 0.7), 40%);

  &__wrapper {
    height: fit-content;
    width: fit-content;
    margin: 0 auto;
    margin-top: 40vh;
  }

  &__slice {
    box-sizing: border-box;
    display: block;
    border-style: solid;
    border-radius: 50%;
    position: absolute;
    animation: spin 1.1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-width: 3px
  }

  &__label {
    position: relative;
    top: 2.5rem;
    left: -0.6rem;
  }
}

.loader div:nth-child(1) {
  animation-delay: -0.3s;
}
.loader div:nth-child(2) {
  animation-delay: -0.2s;
}
.loader div:nth-child(3) {
  animation-delay: -0.1s;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
